import {Component, Input} from "@angular/core";

@Component({
    selector: "app-field-info",
    templateUrl: "./field-info.component.html",
    standalone: false
})
export class FieldInfoComponent {

  @Input()
  infoText: string | undefined;

  @Input()
  testId!: string;
}
